<template>
  <div class="content">
        <div class="build-CURD">
          <div class="build-bar">
            <div slot="header" class="clearfix">
                <el-page-header @back="goBack" content="题库列表"></el-page-header>
            </div>
            <!-- <span>题库：</span>
            <el-select v-model="search.storeId" placeholder="请选择" @change="selcetKu" filterable clearable>
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select> -->
            <!-- <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button> -->
            <el-button type="primary" class="add-user" @click="addFun">添加试题</el-button>
          </div>
          <div class="build-table">
            <ul style="width:100%;position: relative;height: calc( 100% - 6vh );overflow: auto;" class="listQ">
                <li v-for="item in listData" :key="item.id" style="text-align: left;">
                    <p style="font-weight: bold;font-size: 16px;">{{item.index}}、{{item.questWord}}  
                        （<span v-if="item.questType==1">单选题</span><span v-if="item.questType==2">多选题</span><span v-if="item.questType==3">判断题</span>）
                        <i id="" class="el-icon-delete qDel" style="color:red;cursor: pointer;" @click="delExam(item)"></i>
                    </p>
                    <div style="margin-left:20px;">
                        <p v-for="child in item.options" :key="child.id">{{child.opOption}}:{{child.opWord}}</p>
                    </div>
                    <p style="font-weight: bold;font-size: 14px;">答案：{{item.answer}}<a @click="handleEdit(item)" style="margin-left:10px;color:blue;cursor: pointer;">修改</a></p>
                </li>
            </ul>
            <!-- 分页展示 -->
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
            <!-- 新增窗口 -->
            <!-- <el-dialog
              :title="dialogTitle"
              :visible.sync="addFormVisible"
              center
              width="800px"
              :append-to-body="true"
              :lock-scroll="false"
              class="add-form"
            >
              <el-form :model="addForm" label-width="120px" ref="ruleForm">
                <el-form-item label="姓名" required>
                  <el-input v-model="addForm.name" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="身份证" required>
                  <el-input v-model="addForm.idcard" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号码">
                  <el-input v-model="addForm.phone" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="性别">
                  <el-radio-group v-model="addForm.sex">
                    <el-radio  label="1">男</el-radio>
                    <el-radio label="0">女</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="所属部门">
                  <el-input v-model="addForm.officeName" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="状态" >
                  <el-radio-group v-model="addForm.endFlag">
                    <el-radio  label="1">在职</el-radio>
                    <el-radio label="0">离职</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="addFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="sumbitAddRow('ruleForm')">确 定</el-button>
              </div>
            </el-dialog> -->
          </div>
        </div>
  </div>
</template>

<script>
import myHttp from "../../untils/port.js";
import util from "../../untils/util.js"
import base from '../../untils/base'
export default {
  data() {
    return {
      search:{  //查询
        storeId:'',
      },
       entId: '',
      addForm: {
        entId: '',
        id: '',
        parentName: '',
        parentId: '',
        name: '',
        endFlag: '0',
        sort: '',
        remarks: '',
        active: ''
      },
      listData:[], //表格数据
      groupId:'',
      currentPage:1,
      pageSize:10,
      totalItems:0,
      options:[],
      // addFormVisible:false,
      // dialogTitle:''
      groupType:'',
    }
  },
  mounted(){
    this.groupId = util.session.get('groupId');
    if(util.session.get('roleId')=='3'){
      this.groupType = '3';
    }else if(this.$store.state.roleId=='4'){
      this.groupType = '1';
    }else if(this.$store.state.roleId=='5'){
      this.groupType = '2';
    }
    // this.getStore();
    this.search.storeId = this.$route.query.id
    this.getData();
  },
  methods: {
    goBack(){
      this.$router.push({
        path:'/examBank',
      })
    },
    //获取题库
    getStore(){
      var that = this;
      myHttp.getAllStore({
        groupId:this.groupId,
        groupType:this.groupType,
        module:'enterprise',
        storeType:'1'
      }).then(function(resp){
        if(resp.data.code=="200"){
          that.options = resp.data.data.storeList||[];
        }
      });
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage();
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData();
    },
    // 获取数据
    getData() {
      var that = this;
      myHttp.getExamList({
        pageNum:this.currentPage,
        pageSize:this.pageSize,
        storeId:this.search.storeId,
        // groupId:this.groupId,
        groupType:this.groupType
      }).then(function(resp){
        if(resp.data.code=="200"){
          var list = resp.data.data.pageInfo.list||[];
          for(var i=0;i<list.length;i++){
            list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
          }
          that.listData = list;
          that.totalItems = resp.data.data.pageInfo.total||0
        }
      });
      // myHttp.getEntPerson(this.search).then(function(resp){
      //   if(resp.data.code=="200"){
      //       var list = resp.data.data.pageInfo||[];
      //       that.listData = list;
      //   }else{
      //     that.$message.error(resp.data.msg);
      //   }
      // },function(){});
    },
    //修改
    handleEdit(row){
      if(util.session.get('roleId')=='3'){
          this.$router.push({name: "examDetailBuild", params: {'id': row.id}});
      }else if(util.session.get('roleId')=='5'){
          this.$router.push({name: "examDetail", params: {'id': row.id}});
      }else{
        this.$router.push({name: "examDetailPro", params: {'id': row.id}});
      }
      
    },
    //选择
    selcetKu(){
      this.getData()
    },
    //添加
    addFun(){
      // this.dialogTitle = '添加题目';
      // this.addFormVisible = ture;   examDetailBuild
      if(util.session.get('roleId')=='3'){
        this.$router.push({name: "examDetailBuild", params: {'id': 0}});
      }else if(util.session.get('roleId')=='5'){
        // this.$router.push({name: "examDetail", params: {'id': 0}});
        this.$router.push({
          path:'/examDetail1',
          query:{
            id:0,
            id1:this.$route.query.id
          }
        })
      }else{
        this.$router.push({name: "examDetailPro", params: {'id': 0}});
      }
      
    },
    //删除
    delExam(row){
      var that = this;
      this.$confirm('此操作将永久删除该题目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        myHttp.appExamDel({
          id:row.id,
          storeId:row.storeId
        }).then(function(resp){
          if(resp.data.code=="200"){
              that.$message.success('题目删除成功');
              that.getData();
          }else{
              that.$message.error(resp.data.msg);
          }
        });
      }).catch(err => {})
    },
    
  }
}
</script>

<style>
@import '../../assets/css/common.css';

</style>

<style scoped>
* {
  box-sizing: border-box;
}
.content{
  height: 100%;
  width: 100%;
  
  padding: 1vh;
}
.build-CURD{
  width: 100%;
  height: 100%;
  position: relative;
  background: #fff;
}
.build-table{
  width: 100%;
  height: calc( 100% - 6vh );
  overflow: hidden;
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}
.build-bar{
  text-align: right;
  padding: 1vh;
}
.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.el-dropdown-link {
  cursor: pointer;
  color: #666;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.role-tree {
  overflow-y: scroll;
  min-height: 200px;
}
.build-bar .el-button{
  background-color: #17b2fe;
  border-color: #17b2fe;
  margin-left: 30px;
}
.listQ li{
    padding: 10px;
    border-bottom: 1px solid #ddd;
}
.examList.layui-col-space15{
    margin: 0 10px;
}
.listQ p{
  padding: 5px 0;
}
</style>

<style>
.add-form .el-select .el-input{
  width: 100%;
}
</style>